// tableData.ts
export interface TableDataItem {
   visible: boolean;
   job: JobFolder;
}

export enum JobFolder {
   IMAGE = 'IMAGE',
   KOA = 'Koa',
   CARD_3 = 'Card 3',
   INFINITY_BOX = 'Infinity Box',
   LOVE_CARD = 'Love Card',
   ICELAND_BOOK = 'Iceland Book',
   THANK_YOU_CARD = 'Thank You Card',
   STOLEN_BANKER_BOOK = 'Stolen Banker Book',
   WEDDING_1 = 'Wedding 11',
   WEDDING_2 = 'Wedding 2',
   WEDDING_3 = 'Wedding 3',
   WEDDING_4 = 'Wedding 4',
   SCODIX_PROVEN = 'Future Proven',
}

const LibraryData: TableDataItem[] = [
   { visible: true, job: JobFolder.IMAGE },
   { visible: true, job: JobFolder.CARD_3 },
   { visible: true, job: JobFolder.INFINITY_BOX },
   { visible: true, job: JobFolder.KOA },
   { visible: true, job: JobFolder.LOVE_CARD },
   { visible: true, job: JobFolder.ICELAND_BOOK },
   { visible: true, job: JobFolder.SCODIX_PROVEN },
   { visible: true, job: JobFolder.THANK_YOU_CARD },
   { visible: true, job: JobFolder.STOLEN_BANKER_BOOK },
   { visible: true, job: JobFolder.WEDDING_1 },
   { visible: true, job: JobFolder.WEDDING_2 },
   { visible: true, job: JobFolder.WEDDING_3 },
   { visible: true, job: JobFolder.WEDDING_4 },

   // Add more data as needed
];

export interface LibraryComponentProps {
   LibraryData: TableDataItem[];
   onCellClick: (job: JobFolder) => void; // Function to handle cell click
}

export default LibraryData;
